import { useState, useEffect } from "react";
import { Drawer, Button } from "antd";
import { Link } from "react-router-dom";

export default function Footer() {
  const [contactOpen, setContactOpen] = useState(false);
  const [contactIntent, setContactIntent] = useState("hire");
  const [drawerWidth, setDrawerWidth] = useState(720);
  
  useEffect(() => {
    const handler = () => setContactOpen(true);
    window.addEventListener("open-contact-drawer", handler);
    return () => window.removeEventListener("open-contact-drawer", handler);
  }, []);
  
  useEffect(() => {
    const updateDrawerWidth = () => {
      setDrawerWidth(window.innerWidth < 768 ? window.innerWidth : 720);
    };
    
    updateDrawerWidth();
    window.addEventListener('resize', updateDrawerWidth);
    return () => window.removeEventListener('resize', updateDrawerWidth);
  }, []);

  const locations = [
    "Australia", "Brazil", "Canada", "Germany", "Hong Kong", "Malaysia",
    "Netherlands", "New Zealand", "Saudi Arabia", "Singapore", "South Africa",
    "UAE", "UK", "US",
  ];

  return (
    <>
      <footer className="salt-footer">
        <div className="container">
          <div className="salt-footer__cta">
            <div className="row align-items-center g-4 g-lg-5">
              <div className="col-12 col-lg-6 salt-footer__copy">
                <p className="salt-footer__eyebrow">We are Ampstek Global</p>
                <h2 className="salt-footer__heading">
                  Connecting the best <span className="highlight-ring">people</span>
                  <br />
                  with the best <span className="highlight-underline">organisations</span> around the world.
                </h2>
                <div className="salt-footer__buttons">
                  <Button
                    size="large"
                    className="salt-pill salt-pill--blue"
                    
                  >
                   
                    <a href="/blogs" style={{textDecoration: 'none' }}> Grow your team or strategy</a>
                  </Button>
                  {/* <Button
                    size="large"
                    className="salt-pill salt-pill--outline"
                  >
                    Find your next role
                  </Button> */}
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="salt-footer__image-wrapper">
                  <img
                    src="/images/output-onlinegiftools (1).gif"
                    alt="Person holding world map with Ampstek locations"
                    className="salt-footer__image"
                  />
                </div>
              </div>
            </div>
          </div>
        <div className="salt-footer__grid">
          <div className="salt-footer__discover">
            <h5>Industry Partnership</h5>
            <div className="salt-footer__chips">
              <img src="/images/in1.svg" alt="Industry Partnership" className="salt-footer__svg-img" />
              <img src="/images/in2.svg" alt="Industry Partnership" className="salt-footer__svg-img" />
              <img src="/images/in3.svg" alt="Industry Partnership" className="salt-footer__svg-img" />
              <img src="/images/in4.svg" alt="Industry Partnership" className="salt-footer__svg-img" />
              <img src="/images/in5.svg" alt="Industry Partnership" className="salt-footer__svg-img" />
            </div>
          </div>
          <div className="salt-footer__discover">
            <h5>Our Quality Badges</h5>
            <div className="salt-footer__chips">
              <img src="/images/badge1.svg" alt="Quality Badge 1" className="salt-footer__svg-img" />
              <img src="/images/badge2.svg" alt="Quality Badge 2" className="salt-footer__svg-img" />
            </div>
          </div>
          </div>

          <div className="salt-footer__links">
            <div>
              <h5>Company</h5>
              <ul>
                <li><Link to="/about-us" style={{ color: 'inherit', textDecoration: 'none' }}>About Us</Link></li>
                <li><Link to={{ pathname: "/", hash: "#latest-insights" }} style={{ color: 'inherit', textDecoration: 'none' }}>Insights</Link></li>
                <li><Link to="/blogs" style={{ color: 'inherit', textDecoration: 'none' }}>Blogs</Link></li>
                <li><Link to={{ pathname: "/", hash: "#continents" }} style={{ color: 'inherit', textDecoration: 'none' }}>Meet Ampstek</Link></li>
                <li><Link to="/careers" style={{ color: 'inherit', textDecoration: 'none' }}>Careers</Link></li>
                <li><Link to="/contact-us" style={{ color: 'inherit', textDecoration: 'none' }}>Contact Us</Link></li>
              </ul>
            </div>
            <div>
              <h5>Additional Links</h5>
              <ul>
                <li><Link to="/privacy-policy" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy Policy</Link></li>
                <li><Link to="/cookie-policy" style={{ color: 'inherit', textDecoration: 'none' }}>Cookie Policy</Link></li>
                <li><Link to="/terms-and-conditions" style={{ color: 'inherit', textDecoration: 'none' }}>Terms and Conditions</Link></li>
              </ul>
            </div>
            <div>
              <h5>Our Global Presence</h5>
              <ul>
                <li><Link to="/contact-us?global=Americas" style={{ color: 'inherit', textDecoration: 'none' }}>Americas</Link></li>
                <li><Link to="/contact-us?global=Europe" style={{ color: 'inherit', textDecoration: 'none' }}>Europe</Link></li>
                <li><Link to="/contact-us?global=ANZ" style={{ color: 'inherit', textDecoration: 'none' }}>ANZ | Australia</Link></li>
                <li><Link to="/contact-us?global=Asia_Pacific" style={{ color: 'inherit', textDecoration: 'none' }}>Asia Pacific</Link></li>
                <li><Link to="/contact-us?global=Middle_East" style={{ color: 'inherit', textDecoration: 'none' }}>Middle East</Link></li>
                <li><Link to="/contact-us?global=Africas" style={{ color: 'inherit', textDecoration: 'none' }}>Africas</Link></li>   
              </ul>
            </div>
            <div>
              <h5>Connect with us</h5>
              <div className="salt-footer__chips">
              <a href="https://www.linkedin.com/company/ampstek/" target="_blank" rel="noopener noreferrer">
                <img src="/images/cont1.svg" alt="LinkedIn" />
              </a>
              <a href="https://x.com/AmpsTek" target="_blank" rel="noopener noreferrer">
              <img src="/images/cont2.svg" alt="Twitter" />
              </a>
              </div>
            </div>
          </div>

          <div className="salt-footer__bottom">
            <div className="salt-footer__brand">
              <p>2025 &copy; Ampstek.All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Drawer */}
      <Drawer
        title={null}
        placement="right"
        width={drawerWidth}
        open={contactOpen}
        closable={false}
        rootClassName="contact-drawer"
        destroyOnClose
      >
        <div className="contact-drawer__shell">
          <div className="contact-drawer__header">
            <div>
              <p className="contact-drawer__subtitle">Need talent? Request a callback</p>
              <h3 className="contact-drawer__title">
                This form is for companies looking to hire talent.
              </h3>
            </div>
            <button
              type="button"
              className="contact-drawer__close"
              aria-label="Close contact form"
              onClick={() => setContactOpen(false)}
            >
              ✕
            </button>
          </div>

          {/* <section className="contact-drawer__hero">
            <div>
              <p className="contact-drawer__hero-eyebrow">We are Ampstek Global</p>
              <h4 className="contact-drawer__hero-title">
                Connecting the best people with the best organisations around the world.
              </h4>
              <p className="contact-drawer__hero-text">
                Tell us about your hiring plans and we'll connect you with a specialist talent partner in minutes.
              </p>
            </div>
            <div className="contact-drawer__stats">
              <div>
                <span>24+</span>
                <p>Global offices</p>
              </div>
              <div>
                <span>5</span>
                <p>Continents covered</p>
              </div>
              <div>
                <span>1200+</span>
                <p>placements last year</p>
              </div>
            </div>
          </section> */}

        <div className="contact-drawer__intent">
          {[
            { label: "I am looking for a job", value: "hire" },
            { label: "I have a general enquiry", value: "general" },
          ].map((intent) => (
            <button
              key={intent.value}
              type="button"
              onClick={() => setContactIntent(intent.value)}
              className={`contact-drawer__intent-btn ${
                contactIntent === intent.value ? 'contact-drawer__intent-btn--active' : ''
              }`}
            >
              {intent.label}
            </button>
          ))}
        </div>
        <form className="contact-form">
          <div className="contact-form__row">
            <label className="contact-field">
              First name *
              <input
                type="text"
                className="contact-input"
                placeholder="Jane"
                required
              />
            </label>
            <label className="contact-field">
              Last name *
              <input
                type="text"
                className="contact-input"
                placeholder="Doe"
                required
              />
            </label>
          </div>
          <label className="contact-field">
            Company name *
            <input
              type="text"
              className="contact-input"
              placeholder="Ampstek"
              required
            />
          </label>
          <label className="contact-field">
            Email *
            <input
              type="email"
              className="contact-input"
              placeholder="you@company.com"
              required
            />
          </label>
          <label className="contact-field">
            Phone number *
            <input
              type="tel"
              className="contact-input"
              placeholder="+1 234 567 890"
              required
            />
          </label>
          <label className="contact-field">
            Where are you located?
            <input
              type="text"
              className="contact-input"
              placeholder="City, Country"
            />
          </label>
          <label className="contact-field">
            How can we help?
            <textarea
              rows={4}
              className="contact-input contact-input--textarea"
              placeholder="Share some details about your hiring needs..."
            />
          </label>
          <button
            type="submit"
            className="contact-submit"
          >
            Request a callback
          </button>
        </form>
        <p className="contact-form__disclaimer">
          By submitting, you agree to be contacted about Ampstek opportunities and consent to our privacy policy.
        </p>
        </div>
      </Drawer>
    </>
  );
}
